angular.module('jv.Dashboard.My.Time.To.Fill.Controller', []).controller('jv.Dashboard.My.Time.To.Fill.Controller',
    [ '$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService', '$rootScope', 'jvDashboardFactory', '$jobviteUrls', function($scope, jvDashboardAjaxService, jvContextualLoadingService, $rootScope, jvDashboardFactory, $jobviteUrls) {
      // ////////////////////////////////////////////////////////////////////////////////////
      // Settings specifically for demo
      // ////////////////////////////////////////////////////////////////////////////////////
      // _jvselfUser.companyName = 'Twitter';

      // ////////////////////////////////////////////////////////////////////////////////////
      // Initial values
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.userReqInfo = {};
      $scope.userReqInfo.reqList = [];
      $scope.pageSize = 4;
      $scope.totalCount = 0;
      $scope.currentPage = 0;
      $scope.ttfModel = [];
      var initialPageNumber = 0, sortBy, sortOrder, postingTypes, subsidiaries, regions, locations, departments, categories, reqTypes, sourceIds, hiringManagerIds;
      // all flags here
      $scope.flags = {
        'showNoReqsError' : false
      // will be used to show the error message.
      };
      // config to keep track of user permissions
      $scope.userPermissions = {
        canAddRequisition : _permissions && _permissions.canAddRequisition
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // Refresh setting
      // ////////////////////////////////////////////////////////////////////////////////////
      var widgetObject = $scope.widgetObject;
      jvContextualLoadingService.show($scope.widgetObject.widgetId);
      $scope.refreshTimestamp = true;
      $rootScope.$on('REFRESH_WIDGET', function(event, widgetData) {
        if (widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)) {
          $scope.refreshWidget();
        }
      });

      // ////////////////////////////////////////////////////////////////////////////////////
      // Refresh setting
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.refreshWidget = function() {
        $scope.refreshTimestamp = false;
        getWidgetSettings();
        $scope.fetchPage(0);
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // Start the chain - we probably want to refactor as deep
      // chaining is hard to
      // maintain.
      // fetchPage -> getUserRequisitions -> renderPage
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.fetchPage = function(pageNumber) {
        // Hide widget
        jvContextualLoadingService.show($scope.widgetObject.widgetId);
        $scope.getUserRequisitions(pageNumber);
      }

      // ////////////////////////////////////////////////////////////////////////////////////
      // Get User workflows and widget settings. This only needs
      // to be called once.
      // Borrow from my open jobs widget.
      // ////////////////////////////////////////////////////////////////////////////////////
      function getWidgetSettings() {
        var settingsInfo = $scope.widgetObject.userWidgetSettings.widgetSetting;
        angular.forEach(settingsInfo, function(settingInfo, index) {
          var values;
          if (settingInfo.userValues) {
            values = settingInfo.userValues;
          } else if (settingInfo.settings.defaultValues) {
            values = settingInfo.settings.defaultValues;
          }

          if (values) {
            if (values[0] && angular.isObject(values[0].label) && values[0].EId) {
              values[0].value = angular.copy(values[0].EId);
              if (values[0].label.name) {
                values[0].label = angular.copy(values[0].label.name);
              }
              /*
               * The API for fetching the list of hiring managers
               * has the name returned as fullName. We need this
               * for the hiring manager filter in settings
               */
              else if (values[0].label.fullName) {
                values[0].label = angular.copy(values[0].label.fullName);
              }
              delete values[0].EId;
            } else if (values[0].label && values[0].label.name) {
              // filters with label and no EId property
              // Eg: SourceType
              // posting type has index attribute. Check
              // for undefined as 0 can be a value
              if ((values[0].label.index != undefined) && (values[0].label.index !== null)) {
                values[0].index = angular.copy(values[0].label.index);
              }
              values[0].value = angular.copy(values[0].label.name);
              values[0].label = angular.copy(values[0].label.name);
            }
            // Making sure UI doesnt make a call with all
            // filter
            if ($.isEmptyObject(values[0].label)) {
              values[0].label = '';
              values[0].value = null;
            }
            switch (settingInfo.settings.name) {
            case "SortBy":
              sortBy = values[0].value;
              break;
            case "SortOrder":
              sortOrder = values[0].value;
              break;
            case "PostingType":
              if (values[0]) {
                // check for undefined as 0 can be a
                // value
                if ((values[0].index != undefined) && (values[0].index !== null)) {
                  values[0].value = angular.copy(values[0].index);
                  delete values[0].index;
                }
              }
              postingTypes = values[0].value;
              break;
            case "Company":
              subsidiaries = values[0].value;
              break;
            case "Region":
              regions = values[0].value;
              break;
            case "Location":
              locations = values[0].value;
              break;
            case "Department":
              departments = values[0].value;
              break;
            case "Category":
              categories = values[0].value;
              break;
            case "RequisitionType":
              reqTypes = values[0].value;
              break;
            case "SourceType":
              sourceIds = values[0].value;
              $scope.sourceNameFilter = sourceIds;
              break;
            case "HiringManager":
              hiringManagerIds = values[0].value;
              break;
            default:
              break;
            }
          }

        });

      }

      // ////////////////////////////////////////////////////////////////////////////////////
      // String point for each page.
      // Borrow from my open jobs widget.
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.getUserRequisitions = function(page) {
        $scope.currentPage = page;

        // prepares the data for rendering in the grid.
        var massageData = function(reqList) {
          var jobHashWithWorkflowName;
          if (angular.isUndefined($scope.jobHashWithWorkflowName)) {
            jobHashWithWorkflowName = {};
          } else {
            jobHashWithWorkflowName = $scope.jobHashWithWorkflowName;
          }

          for (var i = 0, j = reqList.length; i < j; i++) {
            var reqObj = reqList[i];
            jobHashWithWorkflowName[reqObj.job.EId] = {};
            for (var ii = 0, jj = reqObj.workflowGroup.length; ii < jj; ii++) {
              var workflow = reqObj.workflowGroup[ii];
              // Fix for HIRE-8396 : NV
              var title = workflow.candidateState.title.trim();
              jobHashWithWorkflowName[reqObj.job.EId][title] = workflow.count;
            }
          }
          $scope.jobHashWithWorkflowName = jobHashWithWorkflowName;
        };

        // callback that gets called after the user info is
        // returned.
        var _callback = function(results) {
          $scope.lastUpdated = results.lastUpdated;
          if (results && results.reqList) {
            massageData(results.reqList);
            $scope.userReqInfo.reqList = angular.copy(results.reqList);
            $scope.totalCount = results.total;
            $scope.getUserTTFPrediction();
          }
          if (results.reqList.length === 0) {
            $scope.flags.showNoReqsError = true;
          } else {
            $scope.flags.showNoReqsError = false;
          }
        };

        var args = {
          page : $scope.currentPage,
          maxResults : $scope.pageSize,
          sortBy : sortBy,
          order : sortOrder,
          subsidiaryId : subsidiaries,
          regionIds : regions,
          locationIds : locations,
          departmentIds : departments,
          categoryIds : categories,
          typeIds : reqTypes,
          postingType : postingTypes,
          sourceIds : sourceIds,
          hiringManagerIds : hiringManagerIds
        };
        /*
         * Making sure we send refresh true for new widget creating flow
         * Cannot set refresh true in the REFRESH_WIDGET emit callback
         * since the controller gets re-initialized for a newly added
         * widget. Hence storing this in the factory
         */
        if ($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject)) {
          args.refresh = true;
        }
        jvDashboardAjaxService.getMyOpenJobsInfo(args, _callback);
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // Get TTF prediction
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.getUserTTFPrediction = function() {
        var eid = [];
        angular.forEach($scope.userReqInfo.reqList, function(req, key) {
          eid.push(req.job.EId);
        });
        jvDashboardAjaxService.getTTFPrediction({
          eid : eid
        }, function(response) {

          $scope.refreshTimestamp = true;
          // response is an array of TTFPredictionModel
          $scope.ttfModel = angular.copy(response);
          // Company name will be set via global
          // Render the first page
          $scope.renderPage();

        });
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // TTF Model - TODO: Remove before GA.
      // ////////////////////////////////////////////////////////////////////////////////////
      /**
       * model: { "calculationTime": "2016-04-05", <br>
       * "cbsacode": "string", <br>
       * "cbsaname": "string", <br>
       * "companyCategoryTimeToFill": 0, <br>
       * "companyCategoryTtfSampleCount": 0, <br>
       * "companyId": 0, <br>
       * "expectedHireCount": 0, <br>
       * "expectedHireFromForemostStateCount": 0, <br>
       * "expectedTimeToFill": 0, <br>
       * "foremostStateName": "string", <br>
       * "industryCategoryTimeToFill": 0, <br>
       * "industryCategoryTtfSampleCount": 0, <br>
       * "jobCategory": "string", <br>
       * "jobId": 0, <br>
       * "jobOpenedDays": 0, <br>
       * "jobTitle": "string", <br>
       * "modelTrainingSampleCount": 0, <br>
       * "standardJobCategory": "string" <br>, "toolTips": {}, "notes":
       * {}}
       */

      // ////////////////////////////////////////////////////////////////////////////////////
      // Icons
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.strings = {};
      $scope.strings.icon = {};
      $scope.strings.icon.alert = '<span class="ui-icon ui-icon-alert" style="display:inline-block"></span>';
      $scope.strings.icon.check = '<span class="ui-icon ui-icon-check" style="display:inline-block"></span>';

      // ////////////////////////////////////////////////////////////////////////////////////
      // Render Page
      // ////////////////////////////////////////////////////////////////////////////////////
      $scope.renderPage = function() {
        // Reset x axis
        $scope.chartConfig.options.xAxis.categories = [];
        // Reset data for each series but keep the format
        angular.forEach($scope.chartConfig.series, function(value, key) {
          value.data = []
        });

        // Push series
        // Notice we should iterate through req list instead of
        // TTF model - the
        for (var i = 0; i < $scope.userReqInfo.reqList.length; i++) {
          /*
           * req = { job : {Object EId : "oDW9Vfwn" locationName :
           * "Copenhagen" requisitionId : "R-00347 " title : "fdsa"}
           * workflowGroup : Array[1]}
           */
          var req = $scope.userReqInfo.reqList[i];
          // Notice that we will need to make it null in every
          // loop
          var model = null;
          angular.forEach($scope.ttfModel, function(value, key) {
            // Map job using EId instead of job title.
            if (value.jobEId == req.job.EId) {
              model = value;
              model.jobTitle = model.jobTitle || req.job.title;
            }
          });
          if (!model) {
            // wliao 07/27/2016 Backend now will generate prediction
            // even for
            continue;
          }
          // var model = $scope.ttfModel[i];
          // Push X axis categories
          $scope.chartConfig.options.xAxis.categories.push(model.jobTitle + '|' + req.job.EId + '|' + req.job.requisitionId);
          // This will trigger the redraw
          // Update series data See
          // https://jobvite.atlassian.net/wiki/display/BD/Messages+to+Show+in+Widget

          // Default height when data is missing
          /***********************************************************
           * Template for missing data
           **********************************************************/
          var missingDataHeight = 35;
          var missingDataColor = 'rgba(255, 255, 255, 0.1)';
          var missingDataPoint = {
            custom : true,
            popup : false,
            y : missingDataHeight,
            color : missingDataColor,
            tooltip : $scope.strings.icon.alert,
            dashStyle : 'dash',
            borderColor : '#49667F',
            dataLabels : {
              enabled : true,
              useHTML : true,
              align : 'center',
              padding : 0,
              allowOverlap : true,
              reserveSpace : false,
            }
          };

          /***********************************************************
           * Industrial Benchmark
           **********************************************************/
          // Not Calculated
          var industryBenchmarkDataPoint;
          if (!model.calculationTime) {
            industryBenchmarkDataPoint = angular.copy(missingDataPoint);
            industryBenchmarkDataPoint.y = model.industryCategoryTimeToFill;
            industryBenchmarkDataPoint.tooltip += (model.toolTips.industry || "");

          } else if (model.industryCategoryTimeToFill == null) {
            industryBenchmarkDataPoint = angular.copy(missingDataPoint);
            industryBenchmarkDataPoint.tooltip += (model.toolTips.industry || "");
          } else {
            industryBenchmarkDataPoint = {
              custom : true,
              popup : false,
              y : model.industryCategoryTimeToFill,
              tooltip : '<b>Benchmark</b><br><b>Median Time to Fill: </b>' + model.industryCategoryTimeToFill + '<br /><b>Location: </b>' + model.cbsaname + '<br /><b>Job Category: </b>' + model.standardJobCategory,
            }
          }

          industryBenchmarkDataPoint.borderColor = '#438A88';
          // Push industry benchmark data point
          $scope.chartConfig.series[0].data.push(industryBenchmarkDataPoint);

          /***********************************************************
           * Company Benchmark
           **********************************************************/
          // Not Calculated
          var companyBenchmarkDataPoint;
          if (!model.calculationTime) {
            companyBenchmarkDataPoint = angular.copy(missingDataPoint);
            companyBenchmarkDataPoint.y = model.companyCategoryTimeToFill;
            companyBenchmarkDataPoint.tooltip += (model.toolTips.company || "");

          } else if (model.companyCategoryTimeToFill == null) {
            // Company Benchmark Case 3: No data
            companyBenchmarkDataPoint = angular.copy(missingDataPoint);
            // widget pop-up case 6
            // Match Industrial benchmark if exists
            if (model.industryCategoryTimeToFill > 0) {
              companyBenchmarkDataPoint.y = model.industryCategoryTimeToFill;
            }
            companyBenchmarkDataPoint.tooltip += (model.toolTips.company || "");
          } else {
            companyBenchmarkDataPoint = {
              custom : true,
              popup : false,
              y : model.companyCategoryTimeToFill,
              tooltip : '<b>' + _jvselfUser.companyName + '</b><br><b>Median Time to Fill: </b>' + model.companyCategoryTimeToFill + '<br /><b>Job Category: </b>' + model.jobCategory + '<br />',
            }
          }
          companyBenchmarkDataPoint.borderColor = '#55ABA8';
          // Push company benchmark data point
          $scope.chartConfig.series[1].data.push(companyBenchmarkDataPoint);

          /***********************************************************
           * Days opened - notice that this is the 4th series and TTF
           * is the third.
           **********************************************************/
          var ttf = model.expectedTimeToFill;
          var daysOpened = model.jobOpenedDays;
          if (model.isTooNewToShow) {
            $scope.chartConfig.series[3].data.push({
              y : null,
              popup : false,
              dataLabels : {
                enabled : false,
              }
            });
          } else {
            var daysOpenedData = {
              y : daysOpened,
              custom : true,
              tooltip : '<b>' + model.jobTitle + '</b><br><b>Days Opened: </b>' + daysOpened + '<br /><b>Est. Time to Fill: </b>' + (ttf != null ? ttf : 'N/A') + '<br /><b>Total: </b>' + (ttf != null ? (daysOpened + ttf) : 'N/A'),
              popup : false
            };
            $scope.chartConfig.series[3].data.push(daysOpenedData);
          }
          /***********************************************************
           * TTF tooltips - see
           * https://jobvite.atlassian.net/wiki/display/BD/Messages+to+Show+in+Widget
           **********************************************************/
          var ttfData = {
            y : ttf,
            custom : true,
            popup : false,

          };
          // Not Calculated
          var ttfDataPoint;
          if (!model.calculationTime) {
            ttfDataPoint = angular.copy(missingDataPoint);
            ttfDataPoint.y = model.expectedTimeToFill;
            ttfDataPoint.tooltip += (model.toolTips.prediction || "");

          } else if (model.expectedTimeToFill == null) {
            // Company Benchmark Case 3: No data
            ttfDataPoint = angular.copy(missingDataPoint);
            // widget pop-up case 6
            // Match Industrial benchmark if exists
            if (model.companyCategoryTimeToFill > 0) {
              ttfDataPoint.y = model.companyCategoryTimeToFill;
            }
            ttfDataPoint.tooltip += (model.toolTips.prediction || "");
          } else {
            ttfDataPoint = {
              y : ttf,
              custom : true,
              popup : false,
            }
            ttfDataPoint.tooltip = model.toolTips.prediction;
            // Add icons
            if ((model.companyCategoryTimeToFill != null) && ((ttf + daysOpened) < model.companyCategoryTimeToFill)) {
              ttfDataPoint.tooltip = $scope.strings.icon.check + ttfDataPoint.tooltip;
            } else if (model.daysSinceLastTtfImprovement > 6 || model.modelTrainingSampleCount < 5) {
              ttfDataPoint.tooltip = $scope.strings.icon.alert + ttfDataPoint.tooltip;
            }
          }
          ttfDataPoint.borderColor = '#8BE4E1';
          // Push company benchmark data point
          $scope.chartConfig.series[2].data.push(ttfDataPoint);
        }
        // Show widget
        jvContextualLoadingService.hide($scope.widgetObject.widgetId);
        // Refresh time stamp
        $scope.refreshTimestamp = true;

      };

      // //////////////////////////////////////////
      // Highcharts configuration
      // //////////////////////////////////////////

      // mapping between SVG attributes and the corresponding
      // options
      // Notice that in the latest highchart version this option is gone - the series itself will work.
      // http://jsfiddle.net/willieliao/6c48x39v/
      // Highcharts.seriesTypes.bar.prototype.pointAttrToOptions.dashstyle = 'dashStyle';

      $scope.chartConfig = {
        credits : {
          enabled : false
        },
        /*
         * options - should include anything that is watched by
         * highchart-ng or has no api to change. This includes most
         * non-dynamic properties. See
         * https://github.com/pablojim/highcharts-ng -> FAQ
         */
        options : {
          chart : {
            type : 'column'
          },
          plotOptions : {
            column : {
              stacking : 'normal',
              dataLabels : {
                enabled : false,
                color : (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white',
                style : {
                  textShadow : '0 0 1px black',
                  fontWeight : 'normal',
                  fontSize : 9
                }
              }
            }
          },
          legend : {
            itemStyle : {
              fontWeight : 'normal'
            }
          },
          tooltip : {
            headerFormat : '<b>{series.name}</b><br/>',
            pointFormat : '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
            useHTML : true,
            formatter : function() {
              if (this.point.custom)
                return '<div>' + this.point.tooltip + '</div>';
              else
                return '<div><b>' + this.x + '</b><br />' + this.series.name + ': ' + this.y + '<br />Total: ' + this.total + '</div>';
            }

          },
          xAxis : {
            categories : [ ' ', ' ', ' ', ' ' ],
            labels : {
              style : {
                fontSize : '10px',
                color : '#3d87cf'
              },
              formatter : function() {
                var values = this.value.split('|');
                if (values) {
                  var title = values[0];
                  var eId = values[1];
                  var requisitionId = values[2];
                  var reqIdStr = '';
                  if (requisitionId && requisitionId.trim()) {
                    // Notice that requisitionId is fixed length, i.e. having trailing spaces.
                    // AN-2405 Notice that in some cases we requisitionId is '         '
                    reqIdStr = '<br>(' + requisitionId.trim() + ')';
                  }
                  if(enableTTF) {
                    return '<a href="' + $jobviteUrls.jhire + '/modules/requisitions/tabs.html#/analytics/' + eId + '">' + title + reqIdStr + '</a>';
                  } else {
                    return '<a href="' + $jobviteUrls.jhire + '/modules/requisitions/tabs.html#/summary/' + eId + '">' + title + reqIdStr + '</a>';
                  }
                } else {
                  return this.value;
                }

              },
            }
          },
          /* Blank Title */
          title : {
            text : '&nbsp',
            useHTML : true,
            margin : 5
          },
          yAxis : {
            min : 0,
            title : {
              text : 'Days',
              style : {
                fontWeight : 'normal'
              }
            },
            stackLabels : {
              enabled : false,
              style : {
                fontWeight : 'bold',
                color : (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
              }
            }
          }
        },
        series : [ {
          name : 'Benchmark',
          data : [],
          color : '#438A88',
          stack : 'benchmark'
        }, {
          name : _jvselfUser.companyName,
          data : [],
          color : '#55ABA8',
        }, {
          name : 'Est. Days Left',
          dashStyle : 'dash',
          borderColor : ' #8BE4E1',
          data : [],
          color : '#E8FAF9',
          stack : 'Predict',
          events : {
            click : function(e) {
              if (e.point.popup) {
                this.maincontentText = e.point.actions;
                hs.graphicsDir = '//www.highcharts.com/highslide/graphics/';
                hs.outlineType = 'rounded-white';
                hs.wrapperClassName = 'draggable-header';
                hs.captionEval = 'this.a.title';
                hs.showCredits = false;
                hs.marginTop = 20;
                hs.marginRight = 20;
                hs.marginBottom = 20;
                hs.marginLeft = 20;
                hs.htmlExpand(null, {
                  pageOrigin : {
                    x : e.pageX || e.clientX,
                    y : e.pageY || e.clientY
                  },
                  headingText : "Recommend Actions for " + e.point.category,
                  maincontentText : this.maincontentText,
                  width : 450
                });
              }
            }
          }
        }, {
          name : 'Days open',
          data : [],
          color : '#8BE4E1',
          stack : 'Predict'
        } ]

      };

      // //////////////////////////////////////////
      // Let's get the show started!
      // //////////////////////////////////////////
      $scope.refreshWidget();

    } ]);
